/**
 * The legacy `.form-error-message` block: centred semibold dark-red text on a
 * pale red band, sitting under the submit button. Kept as its own component so
 * login, register and the reset flow all render errors identically.
 */
export function FormErrorMessage({ children }: { children: React.ReactNode }) {
  return (
    <div
      role="alert"
      aria-live="assertive"
      className="my-2.5 w-full bg-[#f9dcdc] px-[5px] py-2 text-center font-semibold text-[#a12525]"
    >
      <span>{children}</span>
    </div>
  );
}
